import React from 'react';

export default function SidebarIcon({ name, className, color, variant }: { name: string; className?: string; color?: string; variant?: 'outline' | 'solid' }) {
  const common: any = { className, style: color ? { color } : undefined };
  const useSolid = variant === 'solid';

  // Render icons; when useSolid is true we set fill to currentColor and remove stroke
  const fill = useSolid ? 'currentColor' : 'none';
  const stroke = useSolid ? 'none' : 'currentColor';

  if (name === 'dashboard')
    return (
      <svg {...common} viewBox="0 0 24 24" fill={fill} stroke={stroke}>
        <rect x="3" y="3" width="8" height="8" rx="1" strokeWidth="1.6" />
        <rect x="3" y="13" width="8" height="8" rx="1" strokeWidth="1.6" />
        <rect x="13" y="3" width="8" height="8" rx="1" strokeWidth="1.6" />
        <rect x="13" y="13" width="8" height="8" rx="1" strokeWidth="1.6" />
      </svg>
    );
  if (name === 'pos')
    return (
      <svg {...common} viewBox="0 0 24 24" fill={fill} stroke={stroke}>
        <rect x="3" y="4" width="18" height="6" rx="1.5" strokeWidth="1.6" />
        <rect x="6" y="12" width="12" height="8" rx="1.5" strokeWidth="1.6" />
      </svg>
    );
  if (name === 'lager')
    return (
      <svg {...common} viewBox="0 0 24 24" fill={fill} stroke={stroke}>
        <path d="M3 7l9-4 9 4v10l-9 4-9-4V7z" strokeWidth="1.4" />
      </svg>
    );
  if (name === 'modules')
    return (
      <svg {...common} viewBox="0 0 24 24" fill={fill} stroke={stroke}>
        <path d="M11.5 2c.28 0 .5.22.5.5V4c0 .28-.22.5-.5.5H10.5c-.55 0-1 .45-1 1v.5c0 .28.22.5.5.5h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1H9.5c-.28 0-.5.22-.5.5v1c0 .55-.45 1-1 1H6.5c-.28 0-.5.22-.5.5V15c0 .55.45 1 1 1h1c.28 0 .5-.22.5-.5V15c0-.55.45-1 1-1h1c.28 0 .5-.22.5-.5v-1c0-.55.45-1 1-1h1c.28 0 .5-.22.5-.5v-1c0-.55.45-1 1-1h1c.28 0 .5-.22.5-.5V6c0-.55.45-1 1-1h1c.28 0 .5-.22.5-.5V2.5c0-.28.22-.5.5-.5h-8z" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  if (name === 'billing')
    return (
      <svg {...common} viewBox="0 0 24 24" fill={fill} stroke={stroke}>
        <path d="M4 6h16v12H4z" strokeWidth="1.4" />
        <path d="M8 10h8" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    );
  return null;
}
